// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Oj0FD","notes":"Notes_notes__3XDT5","note":"Notes_note__3PUFH","markdown":"Notes_markdown__12TJH"};